import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = () => {
  // const auth = inject(AuthService);
  // const router = inject(Router);
  // if (auth.isLoggedIn()) {
  //   return true;
  // } else {
  //   router.navigate(['/login']);
  //   return false;
  // }
  return true;
};
